import { Button, Col, Row } from "antd";
import { EmptyContent } from "../EmptyContent";
import { OfficeFolderBanner } from "../Office/OfficeFolderBanner";
import { OfficeList } from "views/desktop/components/OfficeList";
import { SkeletonCard } from "../Loaders/SkeletonCard";
import {
	Subtitle,
	Title,
} from "views/mobile/screens/OfficeSearch/OfficeSearch.styles";
import { dedup } from "lib/functions.js";
import { pathOr } from "ramda";
import { selectCategoryBySlug } from "state/offices/selectors";
import { useFilteredOffices } from "state/offices/hooks";
import { useHistory, useLocation } from "react-router-dom";

import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import queryString from "query-string";
import styled from "styled-components";

export const SearchResults = () => {
	const location = useLocation();
	const history = useHistory();
	const [global] = useGlobal();
	const {
		search: { searchValue },
		categories,
	} = global;
	const queryParams = queryString.parse(location.search);
	const {
		folder: queryFolder,
		category: queryCategory,
		district: queryDistrict,
		query,
	} = queryParams;

	const setDistricts = useDispatch("setDistricts");
	const setResultsQuantity = useDispatch("setResultsQuantity");
	const setSearchValue = useDispatch("setSearchValue");
	const cat = selectCategoryBySlug(categories, queryCategory) || {};

	const isSearchByFolder = queryCategory && queryFolder;

	const [filteredResults, loading, error] = useFilteredOffices(
		queryCategory,
		queryDistrict ? decodeURIComponent(queryDistrict) : null,
		queryFolder,
		searchValue || query
	);

	useEffect(() => () => setSearchValue(""), []);

	useEffect(() => {
		setDistricts(
			filteredResults
				.map(pathOr(null, ["location", "district"]))
				.filter((r) => r)
				.filter(dedup)
		);
		setResultsQuantity({ quantity: filteredResults.length });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filteredResults.length]);

	return (
		<Content>
			<Title>
				{queryFolder ? `${cat.name} / ${queryFolder}` : cat.name}
			</Title>
			<Subtitle>{filteredResults.length} Sucursales encontradas</Subtitle>
			{loading && !filteredResults.length && (
				<Row justify="center" gutter={24}>
					{[1, 1, 1, 1].map((_, i) => (
						<Col key={i}>
							<SkeletonCard size={600}></SkeletonCard>
						</Col>
					))}
				</Row>
			)}
			{!loading && !!filteredResults.length && (
				<>
					<ShowMoreOnScroll>
						{(n) => (
							<OfficeList
								offices={filteredResults}
								limit={Math.min(filteredResults.length, n, 200)}
							/>
						)}
					</ShowMoreOnScroll>
				</>
			)}
			{!loading && !filteredResults.length && (
				<EmptyContent description="No se encontraron resultados..."></EmptyContent>
			)}
		</Content>
	);
};

const OFFICE_LIST_HEIGHT = 190;

export const ShowMoreOnScroll = ({ children }) => {
	const [scrolledScreens, setScroll] = useState(1);

	window.onscroll = () => {
		const screenN = Math.ceil(
			(window.innerHeight + window.scrollY) / window.innerHeight
		);
		if (screenN + 100 > scrolledScreens) setScroll((_) => screenN);
	};

	// this assumes two columns
	const officesByScreen = Math.ceil(
		(window.innerHeight / OFFICE_LIST_HEIGHT) * 2
		//Math.min(Math.floor(window.innerWidth / OFFICE_LIST_WIDTH), 2)
	);

	return children(scrolledScreens * officesByScreen);
};

const Content = styled.div`
	padding: 12px 24px;
`;
